<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.machine.change_owner_all_title')"
      :externaltrigger="dialogtrigger" :external-close-trigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger">
          <v-alert type="info" prominent dense>
            {{ $t('servicesystem.common_objects.machine.change_owner_info') }}
          </v-alert>
          <v-row align="center" no-gutters class="mb-4">
            <v-col cols="0">
              <h6>{{ $t('servicesystem.transfer') }}</h6>
              <v-card width="fit-content" class="px-2 py-1" color="primary" dark flat>
                {{ allMachines ? $t('servicesystem.common_objects.machine.all_machines') :
                  $t('servicesystem.common_objects.machine.selected_machines') }}
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="currentCustomerId" align="center" no-gutters class="mb-4">
            <v-col>
              <h6>{{ $t('servicesystem.from') }}</h6>
              <CustomerSelect :value="currentCustomerId" disabled>
              </CustomerSelect>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters class="mb-10">
            <v-col>
              <h6>{{ $t('servicesystem.to') }}</h6>
              <CustomerSelect v-model="customerId" externaledit :filter="{ ExcludeItemIdList: [currentCustomerId] }"
                disableAttach>
              </CustomerSelect>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn :loading="loading" :disabled="!customerId" :color="customerId ? 'tertiary' : 'disabled'"
          :dark="!!customerId" @click="customerId && !loading ? save() : null">
          {{ $t('servicesystem.common_objects.machine.change_owner') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "TransferMachinesDialog",
  props: {
    externaltrigger: Number,
    currentCustomerId: String,
    allMachines: Boolean,
    saveFunction: {
      type: Function,
      required: true,
    },
  },
  components: {
    SlottedDialog,
    CustomerSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      customerId: null,
      valid: false,
      loading: false,
    };
  },

  methods: {
    async save() {
      this.loading = true;
      await this.saveFunction(this.currentCustomerId, this.customerId)
        .then(() => {
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {},

  watch: {
    externaltrigger: function () {
      //console.log("externaltrigger", this.externaltrigger);
      this.customerId = null;
      this.dialogtrigger++;
    },
  },
};
</script>